function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../locales/keys';
import { BusinessUnitSelectors, FormHelper } from 'invision-core';
import pathOr from 'ramda/src/pathOr';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CreateCustomerStateRegionProvinceValueOptions, CreateEditCustomerSelector, EnableProspectLiteSelector, IsCreatingCustomerSelector } from '../../reducers/selectors/customer.selectors';
import { InvoiceDisplaySelector } from './customer.form.dropdown.selectors';
import { CUSTOMER_CATEGORY } from './create.customer.popup.constants';
import { PROSPECT_LITE_CUSTOMER } from '../shared/constants/customer.constants';
import { clearCreateEditCustomerForm, createCustomer, createEditCustomerFormChanged, setCustomerCategory, setEditAdditionalProperty, updateSubscriber } from '../../reducers/actions/customer.actions';
import { updateOverrideFlag } from '../../reducers/actions/customer.addresses.actions';
import { getErrorLookupObject, getErrorIdentityVerifications } from '../createCustomer/create.customer.constants';
import { apFormHasErrors } from '../main/customercare.page.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import { setForceShowEditFormAddress, validateAddress } from '../../reducers/actions/address.component.actions';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../shared/contextualComponents/address/address.validator.helper';
import { SubscriberAdditionalPropertiesSelector } from '../createCustomer/additionalPropertiesSection/additional.properties.filtered.selector';
import { PreventOverrideFlagSelector } from '../../reducers/selectors/customer.addresses.selectors';
import { FormattedEditCustomerSubscriberIdentitiesSelector } from '../../reducers/selectors/customer.information.selectors';
var mapStateToTarget = function mapStateToTarget(store) {
  return {
    createCustomer: CreateEditCustomerSelector(store),
    createCustomerDriversLicenseStateOptions: CreateCustomerStateRegionProvinceValueOptions(store),
    enableProspectLite: EnableProspectLiteSelector(store),
    formattedEditCustomerSubscriberIdentities: FormattedEditCustomerSubscriberIdentitiesSelector(store),
    invoiceDisplayOptions: InvoiceDisplaySelector(store),
    isCreatingCustomer: IsCreatingCustomerSelector(store),
    isDbss: BusinessUnitSelectors.IsDbss(store),
    preventOverrideFlag: PreventOverrideFlagSelector(store),
    subscriberAdditionalPropData: SubscriberAdditionalPropertiesSelector(store),
    unvalidatedAddresses: UnvalidatedAddressesSelector(store),
    validatedAddresses: ValidatedAddressesSelector(store)
  };
};
var controllerActions = {
  clearCreateEditCustomerForm: clearCreateEditCustomerForm,
  createCustomer: createCustomer,
  createEditCustomerFormChanged: createEditCustomerFormChanged,
  setCustomerCategory: setCustomerCategory,
  setEditAdditionalProperty: setEditAdditionalProperty,
  setForceShowEditFormAddress: setForceShowEditFormAddress,
  updateOverrideFlag: updateOverrideFlag,
  updateSubscriber: updateSubscriber,
  validateAddress: validateAddress
};
var CreateCustomerPopupController = /*#__PURE__*/function () {
  function CreateCustomerPopupController($ngRedux) {
    _classCallCheck(this, CreateCustomerPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      apErrors: [],
      createCustomerFormErrors: [],
      disconnectRedux: null,
      previousAdditionalProperties: null
    });
  }
  return _createClass(CreateCustomerPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.customerCareLocaleKeys = CustomerCareLocaleKeys;
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (this.state.subscriberAdditionalPropData && this.state.subscriberAdditionalPropData.length > 0) {
        this.previousAdditionalProperties = this.state.subscriberAdditionalPropData;
      }

      // Initialize the createCustomer store
      this.actions.setCustomerCategory(this.customerCategory);
      this.actions.createEditCustomerFormChanged(this.customer);
      this.handleClose = function () {
        if (_this.onClose()) {
          _this.onClose()();
        }
      };
      this.onChangedCreateCustomerForm = function (customerModel) {
        if (_this.isLiteCustomer) {
          _this.createCustomerFormWrapper.createCustomerForm.$submitted = true;
        }
        _this.actions.createEditCustomerFormChanged(customerModel);
      };
      this.onSubmitCreateCustomerForm = function () {
        _this.handleApErrors();
        _this.createCustomerFormWrapper.createCustomerForm.$submitted = true;
        var ngFormErrors = _this.createCustomerFormWrapper.createCustomerForm.$error;
        var createCustomerFormNonApErrors = FormHelper.formHasErrors(ngFormErrors, getErrorLookupObject());
        if (getErrorIdentityVerifications(_this.createCustomerFormWrapper.createCustomerForm)) {
          createCustomerFormNonApErrors = createCustomerFormNonApErrors.concat([{
            description: i18n.translate(CustomerCareLocaleKeys.CREATE_CUSTOMER_FORM.ERRORS.SUBSCRIBER_VERIFICATION_INVALID)
          }]);
        }
        _this.createCustomerFormErrors = createCustomerFormNonApErrors.concat(_this.apErrors).filter(Boolean);
        if (!_this.createCustomerFormErrors.length && !_this.isSubmitDisabled()) {
          //TO-DO verify below works
          _this.validateAddressWithAPI().then(function () {
            var addressKey = _this.getAddressKey();
            var validatedAddress = _this.state.validatedAddresses[addressKey];
            if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
              _this.state.createCustomer.Category = _this.customerCategory;
              var formAction = _this.isCreatingCustomer() ? _this.actions.createCustomer : _this.actions.updateSubscriber;
              return formAction(_this.state.createCustomer, _this.state.preventOverrideFlag).then(function (response) {
                if (_this.isLiteCustomer) {
                  _this.recalculateQuote && _this.recalculateQuote()(_this.state.createCustomer);
                }
                _this.actions.updateOverrideFlag(null);
                _this.onSuccess()(response);
              }).catch(function (error) {
                // Catch in the component due to needing to auto scroll the form to the top when api or ui errors
                _this.createCustomerFormErrors.push(error.translatedMessage);
                _this.createCustomerFormWrapper.highlightErrorMessages();
              });
            } else {
              _this.actions.setForceShowEditFormAddress(false);
              _this.createCustomerFormErrors.push({
                translatedMessage: i18n.translate(_this.CustomerCareLocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE)
              });
              _this.createCustomerFormWrapper.highlightErrorMessages();
            }
          }).catch(function (err) {
            _this.createCustomerFormErrors.push(err.translatedMessage);
            _this.createCustomerFormWrapper.highlightErrorMessages();
          });
        }
      };
      this.handleApErrors = function () {
        var apFormErrors = _this.createCustomerFormWrapper.createCustomerForm.addlApi ? _this.createCustomerFormWrapper.createCustomerForm.addlApi.$error : null;
        _this.apErrors = apFormHasErrors(apFormErrors);
      };
      this.isCreatingCustomer = function () {
        return _this.state.createCustomer.Id === undefined;
      };
    }
  }, {
    key: "getDialogTitle",
    value: function getDialogTitle() {
      if (!this.isCreatingCustomer()) {
        return this.customerCareLocaleKeys.EDIT_CUSTOMER;
      } else if (this.customerCategory === CUSTOMER_CATEGORY.COMMERCIAL) {
        return this.customerCareLocaleKeys.CREATE_NEW_COMMERCIAL_CUSTOMER;
      } else if (this.customerCategory === CUSTOMER_CATEGORY.RESIDENTIAL) {
        return this.customerCareLocaleKeys.CREATE_NEW_RESIDENTIAL_CUSTOMER;
      } else {
        return this.customerCareLocaleKeys.CREATE_NEW_CUSTOMER;
      }
    }
  }, {
    key: "isSubmitDisabled",
    value: function isSubmitDisabled() {
      return this.state.isCreatingCustomer || this.state.isDbss && !this.state.createCustomer.SubscriberCurrency;
    }
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['createCustomerFormWrapper', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['createCustomerFormWrapper', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "overrideValidations",
    get: function get() {
      return this.isLiteCustomer ? false : this.customerState !== undefined ? convertStringToNumber(this.customerState) === PROSPECT_LITE_CUSTOMER : this.state.enableProspectLite;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = addressKey && this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true,
          DefaultHome: true,
          DefaultPostal: true,
          DefaultService: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.previousAdditionalProperties && this.previousAdditionalProperties.length > 0) {
        this.actions.setEditAdditionalProperty(this.previousAdditionalProperties);
      } else {
        // clear out the last batch of data so we start with a fresh slate
        this.actions.clearCreateEditCustomerForm();
      }
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./create.customer.popup.html'),
  controller: CreateCustomerPopupController,
  controllerAs: 'CreateCustomerPopup',
  bindings: {
    config: '<',
    customer: '<',
    isCheckoutStep: '<?',
    isCustomerTypeReadOnly: '<?',
    customerCategory: '<',
    customerState: '<?',
    editCustomerMessage: '<?',
    recalculateQuote: '&?',
    invoiceDisplayOptions: '<',
    isLiteCustomer: '<?',
    onClose: '&',
    onSuccess: '&'
  }
};